// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("./MM_context.res.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_unification_debug = require("./MM_unification_debug.res.js");

function proofNodeGetExpr(node) {
  if (node.TAG === "Hypothesis") {
    return node.expr;
  } else {
    return node.expr;
  }
}

function proofNodeGetId(node) {
  return node.id;
}

function stGetExpr(stack, i) {
  return proofNodeGetExpr(stack.nodes[i]);
}

function compareSubArrays(src, srcFromIdx, dst, dstFromIdx, len) {
  var s = srcFromIdx;
  var d = dstFromIdx;
  var srcLen = src.length;
  var dstLen = dst.length;
  if (srcLen < (srcFromIdx + len | 0) || dstLen < (dstFromIdx + len | 0)) {
    return false;
  }
  var sMax = (srcFromIdx + len | 0) - 1 | 0;
  while(s <= sMax && Caml_obj.equal(src[s], dst[d])) {
    d = d + 1 | 0;
    s = s + 1 | 0;
  };
  return s > sMax;
}

function compareExprAfterSubstitution(expr, subs, eqTo) {
  var e = 0;
  var t = 0;
  var eq = true;
  var eLen = expr.length;
  var tLen = eqTo.length;
  while(eq && e < eLen && t < tLen) {
    var s = expr[e];
    if (s < 0) {
      eq = s === eqTo[t];
      t = t + 1 | 0;
    } else {
      var subExpr = subs[s];
      var len = subExpr.length - 1 | 0;
      eq = compareSubArrays(subExpr, 1, eqTo, t, len);
      t = t + len | 0;
    }
    e = e + 1 | 0;
  };
  if (eq && e === eLen) {
    return t === tLen;
  } else {
    return false;
  }
}

function applySubs(expr, subs) {
  var resultSize = {
    contents: 0
  };
  expr.forEach(function (s) {
        if (s < 0) {
          resultSize.contents = resultSize.contents + 1 | 0;
        } else {
          resultSize.contents = (resultSize.contents + subs[s].length | 0) - 1 | 0;
        }
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = expr[e];
    if (s < 0) {
      res[r] = s;
      r = r + 1 | 0;
    } else {
      var subExpr = subs[s];
      var len = subExpr.length - 1 | 0;
      Expln_utils_common.copySubArray(subExpr, 1, res, r, len);
      r = r + len | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function stExtractSubstitution(stack, frame) {
  var subs = new Array(frame.numOfVars);
  var subsLock = Belt_Array.make(frame.numOfVars, false);
  var baseIdx = stack.nodes.length - frame.numOfArgs | 0;
  frame.hyps.forEach(function (hyp, i) {
        if (hyp.typ !== "F") {
          return ;
        }
        var t = hyp.expr[0];
        var v = hyp.expr[1];
        if (subsLock[v]) {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "subsLock[v]"
                },
                Error: new Error()
              };
        }
        var subsExpr = stGetExpr(stack, baseIdx + i | 0);
        if (subsExpr.length < 2) {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "subsExpr->Array.length < 2"
                },
                Error: new Error()
              };
        }
        if (subsExpr[0] !== t) {
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "subsExpr[0] != t"
                },
                Error: new Error()
              };
        }
        subsLock[v] = true;
        subs[v] = subsExpr;
      });
  if (subsLock.some(function (lock) {
          return !lock;
        })) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "subsLock->Array.some(lock => !lock)"
          },
          Error: new Error()
        };
  }
  return subs;
}

function validateTopOfStackMatchesFrame(stack, frame, subs) {
  var baseIdx = stack.nodes.length - frame.numOfArgs | 0;
  frame.hyps.forEach(function (hyp, i) {
        if (!(hyp.typ === "E" && !compareExprAfterSubstitution(hyp.expr, subs, stGetExpr(stack, baseIdx + i | 0)))) {
          return ;
        }
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "!compareExprAfterSubstitution(ess, subs, stack->stGetExpr(baseIdx+i))"
              },
              Error: new Error()
            };
      });
}

var zCode = Belt_Option.getExn("Z".codePointAt(0));

var aCode = Belt_Option.getExn("A".codePointAt(0));

var aCodePrev = aCode - 1 | 0;

var tCode = Belt_Option.getExn("T".codePointAt(0));

var uCode = Belt_Option.getExn("U".codePointAt(0));

var uCodePrev = uCode - 1 | 0;

function compressedProofBlockToArray(str) {
  var len = str.length;
  var res = [];
  var b = 0;
  var e = 0;
  while(e < len) {
    var c = Belt_Option.getExn(str.codePointAt(e));
    if (c === zCode) {
      res.push("Z");
      e = e + 1 | 0;
      b = e;
    } else if (aCode <= c && c <= tCode) {
      res.push(str.substring(b, e + 1 | 0));
      e = e + 1 | 0;
      b = e;
    } else {
      e = e + 1 | 0;
    }
  };
  return res;
}

function compressedProofCharCodeToInt(code) {
  if (code <= tCode) {
    return code - aCodePrev | 0;
  } else {
    return code - uCodePrev | 0;
  }
}

function compressedProofStrToInt(str) {
  var res = 0;
  var base = 1;
  var len = str.length;
  for(var i = len - 2 | 0; i >= 0; --i){
    res = res + Math.imul(base, compressedProofCharCodeToInt(Belt_Option.getExn(str.codePointAt(i)))) | 0;
    base = Math.imul(base, 5);
  }
  return Math.imul(res, 20) + compressedProofCharCodeToInt(Belt_Option.getExn(str.codePointAt(len - 1 | 0))) | 0;
}

function intToCompressedProofStr(i) {
  if (i < 1) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "intToCompressedProofStr: i < 1"
          },
          Error: new Error()
        };
  }
  var res = [String.fromCharCode(aCode + (i - 1 | 0) % 20 | 0)];
  var i$1 = (i - 1 | 0) / 20 | 0;
  while(i$1 > 0) {
    res.push(String.fromCharCode(uCode + (i$1 - 1 | 0) % 5 | 0));
    i$1 = (i$1 - 1 | 0) / 5 | 0;
  };
  res.reverse();
  return res.join("");
}

function verifyDisjoints(subs, frmDisj, isDisjInCtx) {
  var res = {
    contents: undefined
  };
  Belt_MapInt.forEach(frmDisj, (function (n, ms) {
          if (Belt_Option.isNone(res.contents)) {
            return Belt_SetInt.forEach(ms, (function (m) {
                          if (!Belt_Option.isNone(res.contents)) {
                            return ;
                          }
                          var nExpr = subs[n];
                          var nExprEnd = nExpr.length - 1 | 0;
                          var mExpr = subs[m];
                          var mExprEnd = mExpr.length - 1 | 0;
                          for(var nExprI = 1; nExprI <= nExprEnd; ++nExprI){
                            if (Belt_Option.isNone(res.contents)) {
                              var nExprSym = nExpr[nExprI];
                              if (nExprSym >= 0) {
                                for(var mExprI = 1; mExprI <= mExprEnd; ++mExprI){
                                  if (Belt_Option.isNone(res.contents)) {
                                    var mExprSym = mExpr[mExprI];
                                    if (mExprSym >= 0) {
                                      if (nExprSym === mExprSym) {
                                        res.contents = {
                                          TAG: "DisjCommonVar",
                                          frmVar1: n,
                                          expr1: nExpr.slice(1, nExprEnd + 1 | 0),
                                          frmVar2: m,
                                          expr2: mExpr.slice(1, mExprEnd + 1 | 0),
                                          commonVar: nExprSym
                                        };
                                      } else if (!isDisjInCtx(nExprSym, mExprSym)) {
                                        res.contents = {
                                          TAG: "Disj",
                                          frmVar1: n,
                                          expr1: nExpr.slice(1, nExprEnd + 1 | 0),
                                          var1: nExprSym,
                                          frmVar2: m,
                                          expr2: mExpr.slice(1, mExprEnd + 1 | 0),
                                          var2: mExprSym
                                        };
                                      }
                                      
                                    }
                                    
                                  }
                                  
                                }
                              }
                              
                            }
                            
                          }
                        }));
          }
          
        }));
  return res.contents;
}

function applyAsrt(stack, frame, ctx, isDisjInCtx) {
  var stackLength = stack.nodes.length;
  if (stackLength < frame.numOfArgs) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "stackLength < numOfArgs"
          },
          Error: new Error()
        };
  }
  var subs = stExtractSubstitution(stack, frame);
  var err = verifyDisjoints(subs, frame.disj, isDisjInCtx);
  if (err !== undefined) {
    var errMsg = MM_unification_debug.unifErrToStr(err, (function (__x) {
            return MM_context.ctxIntsToStrExn(ctx, __x);
          }), (function (expr) {
            return MM_context.frmIntsToStrExn(ctx, frame, expr);
          }));
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Disjoint verification failed: " + errMsg
          },
          Error: new Error()
        };
  }
  validateTopOfStackMatchesFrame(stack, frame, subs);
  var expr = applySubs(frame.asrt, subs);
  var newNode_0 = stack.nextId;
  var newNode_1 = stack.nodes.slice(stackLength - frame.numOfArgs | 0);
  var newNode_2 = frame.label;
  var newNode_4 = MM_context.isDebug(ctx) ? ({
        exprStr: MM_context.ctxIntsToStrExn(ctx, expr)
      }) : undefined;
  var newNode = {
    TAG: "Calculated",
    id: newNode_0,
    args: newNode_1,
    asrtLabel: newNode_2,
    expr: expr,
    dbg: newNode_4
  };
  stack.nextId = stack.nextId + 1 | 0;
  for(var _for = 1 ,_for_finish = frame.numOfArgs; _for <= _for_finish; ++_for){
    stack.nodes.pop();
  }
  stack.nodes.push(newNode);
}

function applyUncompressedProof(ctx, stack, proofLabels, isDisjInCtx) {
  proofLabels.forEach(function (step) {
        var hyp = MM_context.getHypothesis(ctx, step);
        if (hyp !== undefined) {
          stack.nodes.push({
                TAG: "Hypothesis",
                id: stack.nextId,
                hypLabel: hyp.label,
                expr: hyp.expr,
                dbg: MM_context.isDebug(ctx) ? ({
                      exprStr: MM_context.ctxIntsToStrExn(ctx, hyp.expr)
                    }) : undefined
              });
          stack.nextId = stack.nextId + 1 | 0;
          return ;
        }
        var frame = MM_context.getFrame(ctx, step);
        if (frame !== undefined) {
          return applyAsrt(stack, frame, ctx, isDisjInCtx);
        }
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "The proof step '" + step + "' doesn't refer to a hypothesis or assertion (in uncompressed proof)."
              },
              Error: new Error()
            };
      });
}

function applyCompressedProof(expr, compressedProofBlock, ctx, stack, isDisjInCtx, labels) {
  var pushHypToStack = function (hyp) {
    stack.nodes.push({
          TAG: "Hypothesis",
          id: stack.nextId,
          hypLabel: hyp.label,
          expr: hyp.expr,
          dbg: MM_context.isDebug(ctx) ? ({
                exprStr: MM_context.ctxIntsToStrExn(ctx, hyp.expr)
              }) : undefined
        });
    stack.nextId = stack.nextId + 1 | 0;
  };
  var steps = compressedProofBlockToArray(compressedProofBlock);
  var hyps = MM_context.getMandHyps(ctx, expr, undefined, undefined);
  var hypLen = hyps.length;
  var hypLenPlusLabelsLen = hypLen + labels.length | 0;
  var savedNodes = [];
  Belt_Array.forEach(steps, (function (step) {
          if (step === "Z") {
            var stackLen = stack.nodes.length;
            if (stackLen === 0) {
              throw {
                    RE_EXN_ID: Common.MmException,
                    _1: {
                      msg: "Cannot execute 'Z' command because the stack is empty."
                    },
                    Error: new Error()
                  };
            }
            savedNodes.push(stack.nodes[stackLen - 1 | 0]);
            return ;
          }
          var i = compressedProofStrToInt(step);
          if (i < 1) {
            throw {
                  RE_EXN_ID: Common.MmException,
                  _1: {
                    msg: "Unexpected condition when applying compressed proof: i < 1."
                  },
                  Error: new Error()
                };
          }
          if (i <= hypLen) {
            return pushHypToStack(hyps[i - 1 | 0]);
          }
          if (i <= hypLenPlusLabelsLen) {
            var labelToApply = labels[(i - hypLen | 0) - 1 | 0];
            var hyp = MM_context.getHypothesis(ctx, labelToApply);
            if (hyp !== undefined) {
              return pushHypToStack(hyp);
            }
            var frame = MM_context.getFrame(ctx, labelToApply);
            if (frame !== undefined) {
              return applyAsrt(stack, frame, ctx, isDisjInCtx);
            }
            throw {
                  RE_EXN_ID: Common.MmException,
                  _1: {
                    msg: "The proof step '" + labelToApply + "' doesn't refer to a hypothesis or assertion (in compressed proof)."
                  },
                  Error: new Error()
                };
          }
          var node = Belt_Array.get(savedNodes, (i - hypLenPlusLabelsLen | 0) - 1 | 0);
          if (node !== undefined) {
            stack.nodes.push(node);
            return ;
          }
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Compressed proof refers to a saved step by the index which is out of bounds."
                },
                Error: new Error()
              };
        }));
}

function verifyProof(ctx, expr, proof, isDisjInCtx) {
  var stack = {
    nextId: 0,
    nodes: []
  };
  if (proof.TAG === "Uncompressed") {
    applyUncompressedProof(ctx, stack, proof.labels, isDisjInCtx);
  } else {
    applyCompressedProof(expr, proof.compressedProofBlock, ctx, stack, isDisjInCtx, proof.labels);
  }
  if (stack.nodes.length !== 1) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "stack->Array.length is " + String(stack.nodes.length) + " but must be 1."
          },
          Error: new Error()
        };
  }
  if (!MM_context.exprEq(stGetExpr(stack, 0), expr)) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "stack[0] != expr" + ("\nstack[0] is '" + (function (__x) {
                    return MM_context.ctxIntsToStrExn(ctx, __x);
                  })(stGetExpr(stack, 0)) + "'") + ("\nexpr is     '" + (function (__x) {
                    return MM_context.ctxIntsToStrExn(ctx, __x);
                  })(expr) + "'")
          },
          Error: new Error()
        };
  }
  return stack.nodes[0];
}

exports.proofNodeGetId = proofNodeGetId;
exports.proofNodeGetExpr = proofNodeGetExpr;
exports.verifyProof = verifyProof;
exports.compressedProofBlockToArray = compressedProofBlockToArray;
exports.compressedProofStrToInt = compressedProofStrToInt;
exports.intToCompressedProofStr = intToCompressedProofStr;
exports.verifyDisjoints = verifyDisjoints;
/* zCode Not a pure module */
